import { createSlice } from "@reduxjs/toolkit";
import { formatDate } from "../../utils/DateAndFormat";

const reportsSlice = createSlice({
  name: "reports",
  initialState: {
    // Report filters that will be persisted in localStorage
    reportsFilters: {
      clientId: null,
      startDate: formatDate(
        new Date(new Date().setDate(new Date().getDate() - 30))
      ),
      endDate: formatDate(new Date()),
      appointment: [],
      location: [],
      channel: [],
      provider: [],
      patientTypes: [
        { name: "New Patient", value: 0, id: 1 },
        { name: "Existing Patient", value: 1, id: 2 },
        { name: "Unassigned", value: "null", id: 3 },
      ],
      category: { name: "Week", id: 5 },
      scheduler: [],
      source: [],
    },
    reportsTabValue: "filter",
    reportsToggleValue: "number",
  },
  reducers: {
    // Update entire reports filter object
    updateReportsFilters: (state, action) => {
      state.reportsFilters = action.payload;
    },

    // Update specific filter field
    updateReportsFilterField: (state, action) => {
      const { field, value } = action.payload;
      state.reportsFilters[field] = value;
    },

    // Update tab value
    updateReportsTabValue: (state, action) => {
      state.reportsTabValue = action.payload;
    },

    // Update toggle value (number/percentage)
    updateReportsToggleValue: (state, action) => {
      state.reportsToggleValue = action.payload;
    },

    // Clear all filters and reset to default
    clearReportsFilters: (state) => {
      state.reportsFilters = {
        clientId: null,
        startDate: formatDate(
          new Date(new Date().setDate(new Date().getDate() - 30))
        ),
        endDate: formatDate(new Date()),
        appointment: [],
        location: [],
        channel: [],
        provider: [],
        patientTypes: [
          { name: "New Patient", value: 0, id: 1 },
          { name: "Existing Patient", value: 1, id: 2 },
          { name: "Unassigned", value: "null", id: 3 },
        ],
        category: { name: "Week", id: 5 },
        scheduler: [],
        source: [],
      };
      state.reportsTabValue = "filter";
      state.reportsToggleValue = "number";
    },

    // Reset entire reports state (used on logout)
    resetReportsState: (state) => {
      state.reportsFilters = {
        clientId: null,
        startDate: formatDate(
          new Date(new Date().setDate(new Date().getDate() - 30))
        ),
        endDate: formatDate(new Date()),
        appointment: [],
        location: [],
        channel: [],
        provider: [],
        patientTypes: [
          { name: "New Patient", value: 0, id: 1 },
          { name: "Existing Patient", value: 1, id: 2 },
          { name: "Unassigned", value: "null", id: 3 },
        ],
        category: { name: "Week", id: 5 },
        scheduler: [],
        source: [],
      };
      state.reportsTabValue = "filter";
      state.reportsToggleValue = "number";
    },
  },
});

export default reportsSlice.reducer;

export const {
  updateReportsFilters,
  updateReportsFilterField,
  updateReportsTabValue,
  updateReportsToggleValue,
  clearReportsFilters,
  resetReportsState,
} = reportsSlice.actions;